import { useQuery } from 'react-query'

import { customFieldQueryConfig } from '@webapp/core/query-configs/customField'

interface UseQueryCustomFieldValuesOptions {
  customFieldId: number
  enabled?: boolean
}

/**
 * Every value a dropdown or checkbox custom field can take, including past
 * values that are no longer offered (`isAvailable: false`). Pass
 * `enabled: false` until a field is chosen.
 */
export const useQueryCustomFieldValues = ({
  customFieldId,
  enabled = true,
}: UseQueryCustomFieldValuesOptions) => {
  const { data, isFetching, isLoading, isError, error } = useQuery({
    ...customFieldQueryConfig.getCustomFieldValues(customFieldId),
    enabled,
  })

  return {
    values: data ?? [],
    isFetching,
    isLoading: isLoading && !data,
    isError,
    error,
  }
}
